var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 30,
    fill: "#EBF2DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 29.0185C65.1718 30.2608 63.1477 31.2109 61.0055 31.8323C59.8557 30.5587 58.3276 29.6561 56.628 29.2464C54.9283 28.8367 53.139 28.9398 51.5022 29.5416C49.8653 30.1435 48.4598 31.2151 47.4757 32.6115C46.4916 34.008 45.9765 35.6619 46 37.3496V39.1886C42.645 39.2725 39.3206 38.5557 36.3228 37.1021C33.3251 35.6485 30.7273 33.5977 28.8182 30.8576C28.8182 30.8576 21.1818 47.4094 38.3636 54.7657C34.4319 57.3367 29.7482 58.6258 25 58.4439C42.1818 67.6393 63.1818 58.4439 63.1818 37.2944C63.1801 36.7821 63.1289 36.2711 63.0291 35.7679C64.9775 33.9169 66.3525 31.5798 67 29.0185Z",
    stroke: "#8AAF45",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.89b61ec4e9e87ec08934ff9344d7bc8c.svg";
export { ForwardRef as ReactComponent };